/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { toolsetsListToolSchemaStaticValues } from "../funcs/toolsetsListToolSchemaStaticValues.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListToolSchemaStaticValuesResult } from "../models/components/listtoolschemastaticvaluesresult.js";
import {
  ListToolsetToolSchemaStaticValuesRequest,
  ListToolsetToolSchemaStaticValuesSecurity,
} from "../models/operations/listtoolsettoolschemastaticvalues.js";
import { unwrapAsync } from "../types/fp.js";
export type ListToolSchemaStaticValuesQueryData =
  ListToolSchemaStaticValuesResult;

export function prefetchListToolSchemaStaticValues(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListToolsetToolSchemaStaticValuesRequest,
  security?: ListToolsetToolSchemaStaticValuesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListToolSchemaStaticValuesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListToolSchemaStaticValuesQuery(
  client$: GramCore,
  request: ListToolsetToolSchemaStaticValuesRequest,
  security?: ListToolsetToolSchemaStaticValuesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListToolSchemaStaticValuesQueryData>;
} {
  return {
    queryKey: queryKeyListToolSchemaStaticValues({
      slug: request.slug,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function listToolSchemaStaticValuesQueryFn(
      ctx,
    ): Promise<ListToolSchemaStaticValuesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(toolsetsListToolSchemaStaticValues(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListToolSchemaStaticValues(
  parameters: {
    slug: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "toolsets", "listToolSchemaStaticValues", parameters];
}
